import types from './ActionTypes';

// Interfaces
import { ICourse, IImportCourse, IInstituteList, IDepartmentList, ICArchive } from 'store/StateInterfaces';

// Utils
import displayGlobalMessage from 'Utils/DisplayGlobalMessage';
import getCookie from 'Utils/GetCookie';
import coursesListToMap from 'Utils/CoursesListToMap';
import instituteListToMap from 'Utils/InstituteListToMap';
import departmentListToMap from 'Utils/DepartmentListToMap';


// TODO: Move this to Utils, better create a fetch wrapper in Utils which uses this
function handleErrorsAndExtractJson(response) {
    if (!response.ok) {
        throw Error(response.statusText);
    }
    return response.json();
}

export function loadCoursesListRequest() {
    return dispatch => {
        let coursesListUrl = '/courseware/instructor_courses_json';
        return fetch(coursesListUrl)
            .then(response => response.json())
            .then(courses => {
                let coursesList = JSON.parse(courses['courses']);
                let coursesMap = coursesListToMap(coursesList);
                dispatch(loadCoursesListSuccess(coursesMap));
            }).catch(error => {
                throw (error);
            });
    };
};

export function loadArchiveStatus(courseid) {
    return dispatch => {
        let url = '/courseware/api/course/' + courseid + '/archive_status/?format=json';
        return fetch(url)
            .then(response => response.json())
            .then(archive => {
                dispatch(loadArchiveStatusSuccess(courseid, archive))
            }).catch(error => {
                throw (error);
            });
    };
};

export function loadImportCoursesListRequest() {
    return dispatch => {
        let get_all_courses_url = '/courseware/api/get_all_courses/?format=json';
        fetch(get_all_courses_url)
            .then(response => response.json())
            .then(data => {
                dispatch(loadImportCoursesListSuccess(data));
            })
            .catch(error => {
                displayGlobalMessage('Import Course Failed', 'error');
                throw (error);
            });
    };
};

export function publishCourse(courseId) {
    return dispatch => {
        let url = `/courseware/api/course/${courseId}/publish/?format=json`;
        fetch(
            url, {
            method: 'POST',
            headers: { 'X-CSRFToken': getCookie('csrftoken') }
        })
            .then(response => response.json())
            .then(response => {
                if (response.alert_msg) {
                    alert(response.alert_msg);
                }
                displayGlobalMessage(response.msg, 'success');
                dispatch(publishCourseSuccess(courseId));
            })
            .catch(error => {
                displayGlobalMessage('Request failed', 'error');
                throw (error);
            });
    };
};

export function downloadCourse(courseId, chaps, assigns) {
    return dispatch => {
        let url = `/courseware/api/course/${courseId}/submit_archive/?format=json`;
        let fd = new FormData();
        fd.append('chapters', chaps);
        fd.append('p_assigns', assigns);
        fetch(
            url, {
            method: 'POST',
            headers: { 'X-CSRFToken': getCookie('csrftoken') },
            body: fd
        })
            .then(response => response.json())
            .then(response => {
                if (response.alert_msg) {
                    alert(response.alert_msg);
                }
                // displayGlobalMessage(response.msg, 'success');
                dispatch(downloadCourseSuccess(courseId));
            })
            .catch(error => {
                displayGlobalMessage('Request failed...', 'error');
                throw (error);
            });
    };
};

export function deleteArchive(courseId: number) {
    return dispatch => {
        if (confirm("Are you sure you want to delete the archive of this course?")) {
            let url = `/courseware/delete_archive/${courseId}/?format=json`;
            fetch(
                url, {
                method: 'POST',
                headers: { 'X-CSRFToken': getCookie('csrftoken') }
            })
                .then(response => response.json())
                .then(response => {
                    if (response.success) {
                        displayGlobalMessage(response.msg, 'success');
                        dispatch(deleteArchiveSuccess(courseId));
                    } else {
                        displayGlobalMessage(response.msg, 'error');
                    }
                })
                .catch(error => {
                    displayGlobalMessage('Request failed', 'error');
                    throw (error);
                });
        }

    }
}

export function toggleArchive(courseId: number) {
    return dispatch => {
        let url = `/courseware/toggle_archive/${courseId}/?format=json`;
        fetch(
            url, {
            method: 'POST',
            headers: { 'X-CSRFToken': getCookie('csrftoken') }
        })
            .then(response => response.json())
            .then(response => {
                if (response.success) {
                    displayGlobalMessage(response.msg, 'success');
                    dispatch(toggleArchiveSuccess(courseId));
                } else {
                    displayGlobalMessage(response.msg, 'error');
                }
            })
            .catch(error => {
                displayGlobalMessage('Request failed', 'error');
                throw (error);
            });
    }
}

export function deleteCourse(courseId: number) {
    return dispatch => {
        if (confirm("Are you sure you want to delete this course?")) {
            let url = `/courseware/api/course/${courseId}`;
            fetch(
                url,
                {
                    method: 'delete',
                    headers: { 'X-CSRFToken': getCookie('csrftoken') }
                })
                .then(() => {
                    displayGlobalMessage('The course was successfully deleted', 'success');
                    dispatch(deleteCourseSuccess(courseId));
                })
                .catch(() => {
                    displayGlobalMessage('The course could not be deleted', 'error');
                });
        }

    };
};

export function getAllInstitute() {
    return dispatch => {
        let getAllInstituteUrl = '/courseware/get_allinstitutes';
        return fetch(getAllInstituteUrl)
            .then(response => response.json())
            .then(institutes => {
                let instituteMap = instituteListToMap(institutes['institutes']);
                dispatch(loadInstituteListSuccess(instituteMap));
            })
            .catch(error => {
                throw (error);
            });
    };
}
export function getAllDepartment() {
    return dispatch => {
        let getAllDepartmentUrl = '/courseware/get_alldepartments';
        return fetch(getAllDepartmentUrl)
            .then(response => response.json())
            .then(departments => {
                let departmentsMap = departmentListToMap(departments['departments']);
                dispatch(loadDepartmentListSuccess(departmentsMap));
            })
            .catch(error => {
                throw (error);
            });
    };
}


export function addCourse(data: any) {
    return dispatch => {
        let url = '/courseware/api/offering/?format=json';
        let fd = new FormData();
        fd.append('category', '1');
        fd.append('title', data.title);
        fd.append('enrollment_type', data.enrollment_type);
        if (data.image) {
            fd.append('image', data.image);
        }
        fd.append('institute', data.institute);
        fd.append('department', data.department);
        // fd.append('anonymity', data.anonymity);
        fd.append('notification_toAll', data.notification_toAll);
        fd.append('anonymity_reveal', data.anonymity_reveal);
        fd.append('courseCode', data.courseCode.toUpperCase());
        fd.append('course_type', data.course_type);
        fd.append('import_url', data.import_url);
        fd.append('import_file', data.import_file);
        if (data.course_type == 'I' && (data.import_url == null || data.import_url == '') && (data.import_file == null || data.import_file == '')) {
            displayGlobalMessage('Import File or URL Not Provided!!', 'error');
            return false;
        }
        fetch(url, {
            method: 'POST',
            headers: { 'X-CSRFToken': getCookie('csrftoken') },
            body: fd
        })
            .then(response => {
                if (!response.ok) {
                    let response2 = response.clone();
                    response2.json().then(data => ({
                        data: data,
                        status: data.status
                    }))
                        .then(data => {
                            throw Error(data.data.non_field_errors);
                        }).catch(error => {
                            console.log(error);
                            displayGlobalMessage(`Add Course Failed: ${error}`, 'error');
                        });
                } else {
                    return response.json();
                }
            })
            .then(response => {
                if (response) {
                    dispatch(addCourseSuccess(response));
                    // window.location.href = `/courseware/course/${response.id}`;
                    window.location.href = `frontend/courseware/courselist`;
                }
            })
            .catch(error => {
                console.log(error);
                displayGlobalMessage(`Add Course Failed: ${error}`, 'error');
            });
        return false;
    };
};

export function importCourseRequest(srcCourseId: number, dstCourseTitle: string) {
    return dispatch => {
        let import_course_url = '/concept/copy_course/?format=json';
        let data = { 'src_course': srcCourseId, 'dst_course_title': dstCourseTitle };
        fetch(
            import_course_url, { // TODO: add timout 150000
            method: 'POST',
            headers: {
                'X-CSRFToken': getCookie('csrftoken'),
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
            .then(response => response.json())
            .then(response => {
                if (response['success']) {
                    dispatch(importCourseSuccess(response, dstCourseTitle));
                    displayGlobalMessage('Course Imported Successfully', 'success');
                }
            })
            .catch(error => {
                displayGlobalMessage(`Import Course Failed: ${error}`, 'error');
                throw (error);
            });
    }
};

export function importCourseSuccess(response, title) {
    let course: ICourse = {
        id: response.course_id,
        title: title,
        is_published: false
    };
    return { type: types.IMPORT_COURSE_SUCCESS, course };
};
export function loadArchiveStatusSuccess(courseid, archive: ICArchive) {
    let resp = {
        arch: archive,
        crseid: courseid
    }
    return { type: types.LOAD_ARCHIVE_STATUS_SUCCESS, resp }
}

export function publishCourseSuccess(courseId: number) {
    return { type: types.PUBLISH_COURSE_SUCCESS, courseId };
};

export function downloadCourseSuccess(courseId: number) {
    return { type: types.DOWNLOAD_COURSE_SUCCESS, courseId };
}

export function deleteArchiveSuccess(courseId: number) {
    return { type: types.DELETE_ARCHIVE_SUCCESS, courseId };
};

export function toggleArchiveSuccess(courseId: number) {
    return { type: types.DISABLE_ARCHIVE_SUCCESS, courseId };
};

export function deleteCourseSuccess(courseId: number) {
    return { type: types.DELETE_COURSE_SUCCESS, courseId };
};

export function loadCoursesListSuccess(instructorCoursesMap: Map<number, ICourse>) {
    return { type: types.LOAD_INSTRUCTOR_COURSES_LIST_SUCCESS, instructorCoursesMap };
};

export function loadInstituteListSuccess(instituteList: Map<number, IInstituteList>) {
    return { type: types.LOAD_INSTITUTE_LIST_SUCCESS, instituteList };
};
export function loadDepartmentListSuccess(departmentList: Map<number, IDepartmentList>) {
    return { type: types.LOAD_DEPARTMENT_LIST_SUCCESS, departmentList };
};

export function loadCoursesListFailure() {
    return { type: types.LOAD_INSTRUCTOR_COURSES_LIST_FAILURE };
};

export function addCourseSuccess(course: ICourse) {
    return { type: types.ADD_COURSE_SUCCESS, course };
};

export function loadImportCoursesListSuccess(data: IImportCourse) {
    return { type: types.LOAD_IMPORT_COURSES_LIST_SUCCESS, data };
};
